import { useQuery } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import { Success } from '@website/components/checkout/Success';
import CustomBreadcrumb from '@website/components/CustomBreadcrumb';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { SuccessBookingPageDocument } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import { Col, Container } from 'react-bootstrap';

type Props = {
  bookingID: string;
};

export function SuccessPageInner({ bookingID }: Props) {
  const { loading, error, data } = useQuery(SuccessBookingPageDocument, {
    variables: {
      bookingID,
    },
  });

  if (loading && !data) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage />;
  }

  return (
    <>
      <Col xs={12} sm={8} md={7} className="mx-auto px-2">
        <CustomBreadcrumb
          items={[
            { text: 'Home', href: '/' },
            { text: 'Dashboard', href: `/me/${data.booking.user.id}` },
            {
              text: 'Booking',
              href: `/me/${data.booking.user.id}/bookings/${data.booking.id}`,
            },
            { text: 'Success', active: true },
          ]}
        />
      </Col>
      <Success booking={data.booking} />{' '}
    </>
  );
}

export default function SuccessPage() {
  const { query } = useRouter();
  const { bookingID } = query;

  return (
    <>
      <Container className="mt-5 mb-5">
        <RequiresAuth>
          <SuccessPageInner bookingID={bookingID as string} />
        </RequiresAuth>
      </Container>
    </>
  );
}
